import request from "../_redux/utils/request";

export async function registerUser(payload) {
  return request({
    url: "/auth/register",
    method: "POST",
    body: payload
  });
}

export async function loginUser(payload) {
  return request({
    url: "/auth/login",
    method: "POST",
    body: payload
  });
}

export async function googleLoginUser(idToken) {
  return request({
    url: "/auth/google",
    method: "POST",
    body: { idToken }
  });
}
